module.exports = __webpack_public_path__ + "static/img/14.3df05bd2.png";